var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDetails(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3176_40796",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3176_40796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 12.75C3.3375 12.75 2.98438 12.6031 2.69063 12.3094C2.39688 12.0156 2.25 11.6625 2.25 11.25V6.75C2.25 6.3375 2.39688 5.98438 2.69063 5.69063C2.98438 5.39688 3.3375 5.25 3.75 5.25H14.25C14.6625 5.25 15.0156 5.39688 15.3094 5.69063C15.6031 5.98438 15.75 6.3375 15.75 6.75V11.25C15.75 11.6625 15.6031 12.0156 15.3094 12.3094C15.0156 12.6031 14.6625 12.75 14.25 12.75H3.75ZM3.75 11.25H14.25V6.75H3.75V11.25ZM2.98125 3.75C2.76875 3.75 2.59375 3.67812 2.45625 3.53437C2.31875 3.39062 2.25 3.2125 2.25 3C2.25 2.7875 2.32187 2.60937 2.46562 2.46562C2.60937 2.32187 2.7875 2.25 3 2.25H15.0187C15.2312 2.25 15.4063 2.32187 15.5438 2.46562C15.6813 2.60937 15.75 2.7875 15.75 3C15.75 3.2125 15.6781 3.39062 15.5344 3.53437C15.3906 3.67812 15.2125 3.75 15 3.75H2.98125ZM2.98125 15.75C2.76875 15.75 2.59375 15.6781 2.45625 15.5344C2.31875 15.3906 2.25 15.2125 2.25 15C2.25 14.7875 2.32187 14.6094 2.46562 14.4656C2.60937 14.3219 2.7875 14.25 3 14.25H15.0187C15.2312 14.25 15.4063 14.3219 15.5438 14.4656C15.6813 14.6094 15.75 14.7875 15.75 15C15.75 15.2125 15.6781 15.3906 15.5344 15.5344C15.3906 15.6781 15.2125 15.75 15 15.75H2.98125Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetails);
export default __webpack_public_path__ + "static/media/Details.cb20886f.svg";
export { ForwardRef as ReactComponent };